import i18n from "../i18n";
import { atom, selector } from "recoil";
import { Storage, API } from "aws-amplify";
import _ from "lodash";
import { getVersionNumber } from "../helpers/general";

const restApiName = "andelRestApi";
const OTA_LIST_PAGE_SIZE = 100;
const FILE_DETAILS_BATCH_SIZE = 10;

export const otaFilesAtom = atom({
	key: "otaFilesAtom",
	default: null,
});

export const otaFilesSelector = selector({
	key: "otaFilesSelector",
	get: async ({ get }) => {
		const allFiles = [];
		let nextToken = undefined;

		do {
			const fileList = await Storage.list(`ota`, { pageSize: OTA_LIST_PAGE_SIZE, nextToken });
			const files = Array.isArray(fileList) ? fileList : fileList?.results || [];
			allFiles.push(...files);
			nextToken = Array.isArray(fileList) ? undefined : fileList?.nextToken;
		} while (nextToken);
		const fileResults = [];
		const userCache = new Map();

		const getUploadedByName = async (uploadedBy) => {
			if (!uploadedBy) return i18n.t("user.common.deleted");
			if (userCache.has(uploadedBy)) return userCache.get(uploadedBy);

			const userRequest = API.get(
				restApiName,
				`/user/byAttribute?name=sub&type=%3D&value=${uploadedBy}`
			)
				.then((users) =>
					users.length ? users[0].fullname : `${i18n.t("user.common.deleted")}: ${uploadedBy.slice(-4)}`
				)
				.catch(() => `${i18n.t("user.common.deleted")}: ${uploadedBy.slice(-4)}`);

			userCache.set(uploadedBy, userRequest);
			return userRequest;
		};

		const batches = _.chunk(allFiles, FILE_DETAILS_BATCH_SIZE);
		for (const batch of batches) {
			const batchResults = await Promise.all(
				batch.map(async (file) => {
					const fileData = await Storage.getProperties(file.key);
					const metadata = fileData.metadata || {};
					const uploadedBy = metadata.uploadedby;
					const username = await getUploadedByName(uploadedBy);
					return {
						filename: file.key.substring(4),
						firmwareNumber: getVersionNumber(metadata.firmwareversion || ""),
						uploadedByName: username,
						...fileData,
					};
				})
			);
			fileResults.push(...batchResults);
		}

		return fileResults.sort((a, b) => {
			const aTime = a?.lastModified ? new Date(a.lastModified).getTime() : 0;
			const bTime = b?.lastModified ? new Date(b.lastModified).getTime() : 0;
			return bTime - aTime;
		});
	},
});

export const selectedOtaFileAtom = atom({
	key: "selectedOtaFileAtom",
	default: null,
});

export const otaJobsSelector = selector({
	key: "otaJobsSelector",
	get: async ({ get }) => {
		const otaJobs = await API.get(restApiName, "/ota");

		otaJobs.map((otaJob) => {
			otaJob.createdAt = new Date(otaJob.createdAt);
			otaJob.updatedAt = new Date(otaJob.updatedAt);
		});

		return otaJobs;
	},
});
